@if (selectedSchema$ | async; as schema) {
    <ng-container *transloco="let tHeader; read: 'nav_menu'">
        <div class="text-text headline me-1 primaryColorBG xsm:ms-3">
            {{ tHeader(schema.name) }}
        </div>
        <app-tb-more-menu
            triggerIcon="custom_settings"
            triggerColor="text"
            [replaceable]="true"
            [template]="menu"
            xPosition="before"
        ></app-tb-more-menu>
        <app-tb-button
            (click)="newRecord()"
            [appearance]="'text'"
            [icon]="'add_circle'"
            [filled]="true"
            class="ml-3 hidden md:inline-block"
        >
            <span class="body-2">{{ tHeader('add_new') }}</span>
        </app-tb-button>

        <ng-template
            #menu
            let-containerLayout="containerLayout"
            let-manager="manager"
            let-close="closeFn"
        >
            <app-modal-layout [containerLayout]="containerLayout" (closeModal)="close()">
                <ng-container title>
                    {{ tHeader(schema.name) }} {{ tHeader('settings') }}
                </ng-container>
                <app-tb-menu-list
                    *transloco="let tManageFields; read: 'manage_fields'"
                    [containerLayout]="containerLayout"
                    [insideModalLayout]="true"
                >
                    <app-tb-menu-list-item (click)="manageFields(manager)" icon="edit_note">
                        {{ tManageFields('manage_fields') }}
                    </app-tb-menu-list-item>
                </app-tb-menu-list>
            </app-modal-layout>
        </ng-template>
    </ng-container>
}
